var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23557 22.6563C15.9127 22.6563 20.66 14.8403 20.66 8.06447C20.66 7.84474 20.6555 7.62013 20.6465 7.40041C21.57 6.67447 22.367 5.7753 23 4.74513C22.1399 5.16107 21.2267 5.43272 20.2917 5.5508C21.2762 4.90931 22.0134 3.90156 22.3666 2.71437C21.4404 3.31103 20.4274 3.73192 19.3712 3.959C18.6596 3.13707 17.7186 2.59286 16.6939 2.4105C15.6691 2.22814 14.6176 2.41779 13.702 2.95013C12.7864 3.48247 12.0576 4.32785 11.6283 5.35556C11.199 6.38328 11.0931 7.53609 11.3271 8.63576C9.45156 8.53346 7.61677 8.00389 5.94165 7.08138C4.26653 6.15888 2.78846 4.86403 1.60326 3.28078C1.00088 4.40966 0.816554 5.74549 1.08774 7.01679C1.35892 8.28809 2.06527 9.39945 3.06322 10.125C2.31402 10.0992 1.58123 9.87991 0.925391 9.48537V9.54884C0.924719 10.7335 1.30151 11.8819 1.99171 12.7987C2.68192 13.7156 3.64293 14.3444 4.71141 14.5781C4.01739 14.7845 3.28898 14.8146 2.58256 14.666C2.88406 15.6849 3.47067 16.576 4.26053 17.215C5.05039 17.854 6.00407 18.209 6.9885 18.2305C5.31724 19.6574 3.25275 20.4314 1.12754 20.4277C0.75065 20.4271 0.374132 20.402 0 20.3526C2.15899 21.8581 4.67047 22.6577 7.23557 22.6563Z",
    fill: "#EFEEE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 25,
    fill: "white"
  })))));
}

export default SvgTwitter;